import MainLayout from "screens/partials/layout";
import StorboltCampaignDetailComponent from "screens/partials/meta-ads/campaign-detail";

export default function MetaAdsCampaign() {
    return (
        <MainLayout>
            <StorboltCampaignDetailComponent />
        </MainLayout>
    )
}
